import React from 'react'
import Helmet from 'react-helmet'

import CustomHelmet from '../components/CustomHelmet'
import Apply from '../components/Apply'
import Fellows from '../components/Fellows'
import Hero from '../components/SuccessStories/Hero'
import KeyStats from '../components/SuccessStories/KeyStats'
import StoryCards from '../components/SuccessStories/StoryCards'

class SuccessStories extends React.Component {

  componentDidMount() {
    const ScrollReveal = require('scrollreveal')

    window.setTimeout(() => {
      window.sr = ScrollReveal();
      sr.reveal('.keystat', { duration: 600, delay: 200 }, 80)
      sr.reveal('.quote', { duration: 600 })
      sr.reveal('.profileImage', { duration: 1600, opacity: 0.4, scale: 0.9, delay: -200})
    }, 200)
  }

  render() {
    const { data: { page, fellows } } = this.props;
    const seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : ``;

    return (
      <div className="success">
        <CustomHelmet data={ page.seoData } />
        <Hero
          title={page.title}
        />
        <KeyStats
          keystats={page.keyStats}
        />
        <StoryCards
          successStoryCards={page.successStoryCards}
        />
        <Fellows
          title={fellows.title}
          cards={fellows.fellowsCards}
          link={fellows.link}
        />
        <Apply
          title={'It\'s time to break out from the expected'}
          buttonText="Request Info"
          buttonUrl={ `/#signup` }
        />
      </div>
    );
  }
}

export default SuccessStories

export const query = graphql`
  query SuccessPageQuery {
    fellows: contentfulFellowsParents {
  	  title
      link {
        text
        link
      }
      fellowsCards {
        storyPosition
        storyLocation
        quoteTitle
        attribution
        quoteText
        link
        articleImage {
          sizes(quality:100, maxWidth:400) {
                ...GatsbyContentfulSizes_withWebp
          }
          file {
            url
          }
          title
        }
      }
  	}
    page: contentfulSuccessStoriesPage {
 	  title
      keyStats {
        title
        text {
          text
        }
      }
      successStoryCards {
        name
        profileImage {
            sizes(quality:100, maxWidth:500) {
                ...GatsbyContentfulSizes_withWebp
            }
          file {
            url
            fileName
            contentType
          }
          title
        }
        biopgraphy {
          biopgraphy
        }
        logos {
            sizes(quality:100, maxWidth:600) {
                ...GatsbyContentfulSizes_withWebp
            }
          file {
            url
            fileName
            contentType
          }
          title
        }
        interviewVideoLink
        interviewVideoPlaceholder {
          id
          file {
            url
            fileName
            contentType
          }
        }
        stats {
          title
          text {
            text
          }
        }
        quote {
          quote
        }
      }
      seoData {
        pageTitle
        pageDescription {
          pageDescription
        }
        keywords
        openGraphTitle
        openGraphDescription {
          openGraphDescription
        }
        openGraphImage {
          file {
            url
          }
        }
      }
 		}
  }
`;



// WEBPACK FOOTER //
// ./src/pages/success-stories.js